<template>
    <div ref="pageBox">
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item label="所属工厂">
                    <el-select v-model="fcIdSelected" placeholder="请选择工厂" :clearable="isclear" filterable
                               :disabled="ischeck"
                               @change="fcChange">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.value"
                            :label="factory.label"
                            :value="factory.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择车间" clearable filterable @change="shopChange">
                        <el-option
                            v-for="shop in shopList"
                            :key="shop.value"
                            :label="shop.label"
                            :value="shop.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="sectionSelected" placeholder="请选择工段" clearable filterable
                               @change="sectionChange">
                        <el-option
                            v-for="section in sectionList"
                            :key="section.value"
                            :label="section.label"
                            :value="section.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="lineSelected" placeholder="请选择产线" clearable filterable @change="lineChange">
                        <el-option
                            v-for="line in lineList"
                            :key="line.value"
                            :label="line.label"
                            :value="line.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="单位">
                    <el-select v-model="unit" placeholder="请选择单位" clearable filterable @change="searchTable">
                        <el-option
                            v-for="unit in unitList"
                            :key="unit.unitId"
                            :label="unit.unitDesc"
                            :value="unit.unitDesc">
                        </el-option>
                    </el-select>
                </el-form-item>-->
                <el-form-item label="工装分类">
                    <el-select v-model="classifyId" placeholder="请选择工装分类" clearable filterable @change="searchTable">
                        <el-option
                            v-for="classify in classifyList"
                            :key="classify.tcId"
                            :label="classify.classifyName"
                            :value="classify.tcId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工装状态">
                    <el-select v-model="toolingStatus" placeholder="请选择工装状态" clearable @change="searchTable">
                        <!--<el-option label="闲置中" value="id_le"></el-option>
                        <el-option label="领用中" value="in_use"></el-option>
                        <el-option label="报废中" value="desscrap_type"></el-option>-->
                        <el-option
                            v-for="enumType in enumTypeList"
                            :key="enumType.etId"
                            :label="enumType.etName"
                            :value="enumType.etCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工装名称">
                    <el-input v-model.trim="toolingName" placeholder="请输入工装名称"></el-input>
                </el-form-item>
                <el-form-item label="工装编码">
                    <el-input v-model.trim="toolingCode" placeholder="请输入工装编码"></el-input>
                </el-form-item>
                <el-form-item label="排序字段">
                    <el-select v-model="sortField" placeholder="请选择排序字段" clearable @change="sortFOChange">
                        <el-option label="编号" value="tooling_code"></el-option>
                        <el-option label="剩余寿命" value="residual_life"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序方式">
                    <el-select v-model="sortOrder" placeholder="请选择排序方式" clearable @change="searchTable">
                        <el-option label="升序" value="ASC"></el-option>
                        <el-option label="降序" value="DESC"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="searchTable()">搜索</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="工装清单" ref="LabelContent">
            <div slot="btns">
                <el-button size="small" type="success" @click=";(ifAddText = '0'),updateLingInfo()"> 新增</el-button>
                <el-button size="small" type="success" @click="toolingTemplate()">模板</el-button>
                <el-button size="small" type="success" @click="toolingImport()">导入</el-button>
                <el-button size="small" type="success" @click="exportToolingInfo()">导出</el-button>
                <el-button size="small" type="success" @click="exportToolingInfoRecord()">记录导出</el-button>
                <el-button size="small" type="success" @click=";(record = true),updateToolingRecord()">领用</el-button>
                <el-button size="small" type="warning" @click=";(record = false),updateToolingRecord()">归还</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center"
                      @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="toolingName" label="工装名称" width="110"/>
                <el-table-column prop="toolingCode" label="工装编码" width="120"/>
                <el-table-column prop="fcName" label="工厂" width="120"/>
                <el-table-column prop="shopName" label="车间" width="100"/>
                <el-table-column prop="sectionName" label="工段" width="120"/>
                <el-table-column prop="lineName" label="产线" width="100"/>
                <el-table-column prop="toolingStatus.desc" label="工装状态" width="120"/>
                <el-table-column prop="designLife" sortable label="设计寿命 （次）" width="150"/>
                <el-table-column prop="residualLife" sortable label="剩余寿命（次）" width="150"/>
                <el-table-column prop="lifeDueRemind" sortable label="寿命到期提醒（次）" width="150"/>
                <el-table-column prop="dueDate" label="到期日期" :formatter="this.transformDateFormat" width="160"/>
                <el-table-column prop="dateDueRemind" label="到期提醒日期" :formatter="this.transformDateFormat" width="160"/>
                <el-table-column prop="arrivalDate" label="进厂日期" :formatter="this.transformDateFormat" width="110"/>
                <el-table-column prop="classifyName" label="工装分类名称" width="130"/>
                <el-table-column prop="unit" label="单位"/>
                <el-table-column prop="toolingTuhao" label="工装图号" width="120"/>
                <el-table-column prop="toolingSpecs" label="工装规格" width="120"/>
                <el-table-column prop="toolingBrand" label="工装品牌" width="120"/>
                <el-table-column prop="remark" label="备注" width="100"/>
                <el-table-column prop="supplierCode" label="供应商编号" width="120"/>
                <el-table-column prop="supplierName" label="供应商名称" width="120"/>
                <el-table-column prop="prodDate" label="生产日期" :formatter="this.transformDateFormat"
                                 width="160"/>
                <el-table-column prop="locatorCode" label="位置编号" width="120"/>
                <el-table-column label="操作" width="120" fixed="right">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn el-icon-collection-tag" @click=";(record == true),updateToolingRecord(scope.row)"/>-->
                        <!--                        <i class="collection el-icon-collection" @click=";(record == false),updateToolingRecord(scope.row)"/>-->
                        <i class="document el-icon-document" @click="toolingReCord(scope.row)"/>
                        <i class="editBtn iconfont u-youjianbianji"
                           @click=";(ifAddText = '1'),updateLingInfo(scope.row)"/>
                        <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
        <!--新增工装领用、工装归还-->
        <el-dialog :title="updateRecordTitle" width="50vw" :visible.sync="recordShow" style="text-align:left">
            <el-form :model="useRecordInfo" :rules="useRecord" :ref="refObj" label-width="100px" class="demo-roleForm"
                     v-if="record == true">
                <el-form-item label="工装编码" prop="tiId">
                    <el-select v-model="useRecordInfo.tiId" clearable filterable placeholder="请选择工装编码">
                        <el-option
                            v-for="tooling in toolingInfoList"
                            :key="tooling.tiId"
                            :label="tooling.toolingCode"
                            :value="tooling.tiId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="归还时间">
                    <el-date-picker
                        :picker-options="pickerOptions"
                        v-model="useRecordInfo.useTimeEnd"
                        type="date"
                        placeholder="选择归还时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="员工工号" prop="useUser">
                    <!--<el-input v-model.trim="useRecordInfo.useUser" @blur="queryUserByAccount"></el-input>-->
                    <el-select
                        v-model="useRecordInfo.useUser" filterable clearable remote reserve-keyword
                        placeholder="请输入员工工号"
                        :remote-method="remoteMethod"
                        :loading="loading"
                        @change="queryUserByAccount">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="领用照片">
                    <el-upload
                        v-show="fileUpload"
                        class="upload-demo"
                        :headers="{'X-Auth-Token':token}"
                        :action="URL"
                        :on-success="handleSuccess"
                        :file-list="fileList"
                        :clearFiles="clearFiles"
                        :limit="1">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <span v-show="fileUrlShow">{{useRecordInfo.useFile}}</span>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" v-model.trim="useRecordInfo.remark"></el-input>
                </el-form-item>
            </el-form>
            <el-form :model="revertRecordInfo" :rules="revertRecord" :ref="refObj" label-width="100px"
                     class="demo-roleForm"
                     v-if="record == false">
                <el-form-item label="工装编码" prop="tiId">
                    <el-select v-model="revertRecordInfo.tiId" clearable filterable placeholder="请选择工装编码">
                        <el-option
                            v-for="tooling in toolingInfoList"
                            :key="tooling.tiId"
                            :label="tooling.toolingCode"
                            :value="tooling.tiId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="使用次数">
                    <el-input-number v-model="revertRecordInfo.revertLife" :min="1" placeholder="请输入使用次数">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="员工工号" prop="revertUser">
                    <!--                    <el-input v-model.trim="revertRecordInfo.revertUser" @blur="queryUserByAccount"></el-input>-->
                    <el-select
                        v-model="revertRecordInfo.revertUser" filterable clearable remote reserve-keyword
                        placeholder="请输入员工工号"
                        :remote-method="remoteMethod"
                        :loading="loading"
                        @change="queryUserByAccount">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="归还照片">
                    <el-upload
                        v-show="fileUpload"
                        class="upload-demo"
                        :headers="{'X-Auth-Token':token}"
                        :action="URL"
                        :on-success="handleSuccess"
                        :file-list="fileList"
                        :clearFiles="clearFiles"
                        :limit="1">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <span v-show="fileUrlShow">{{revertRecordInfo.revertFile}}</span>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" v-model.trim="revertRecordInfo.remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="recordShow = false">取 消</el-button>
                <el-button type="primary" @click="updateRecord(refObj)">确定</el-button>
            </span>
        </el-dialog>

        <!--查看工装领用、工装归还计划-->
        <el-dialog title="工装记录" width="70vw" :visible.sync="tooLingShow" style="text-align:left">
            <el-tabs v-model="activeName">
                <!--工装领用-->
                <el-tab-pane label="工装领用" name="first">
                    <div class="tableBox">
                        <el-table stripe ref="multipleTable" :data="useList" class="center">
                            <!--<el-table-column prop="toolingCode" sortable label="工装编码"/>-->
                            <el-table-column prop="useUserName" sortable label="领用人"/>
                            <el-table-column prop="residualLife" sortable label="剩余次数"/>
                            <el-table-column prop="useTimeStart" sortable label="领用时间" width="160"/>
                            <el-table-column prop="useTimeEnd" sortable label="归还时间"
                                             :formatter="this.transformDateFormat"
                                             width="160"/>
                            <el-table-column prop="useFile" sortable label="领用照片">
                                <template slot-scope="scope">
                                    <el-popover placement="left" trigger="click" width="500">
                                        <img :src="scope.row.useFile" width="100%"/>
                                        <img slot="reference" :src="scope.row.useFile" :alt="scope.row.useFile"
                                             style="max-height: 80px; max-width: 80px; padding: 5px"/>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" sortable label="备注"/>
                        </el-table>
                    </div>
                </el-tab-pane>
                <!--工装归还-->
                <el-tab-pane label="工装归还" name="second">
                    <div class="tableBox">
                        <el-table stripe ref="multipleTable" :data="revertList" class="center">
                            <!--<el-table-column prop="toolingCode" sortable label="工装编码"/>-->
                            <el-table-column prop="revertUserName" sortable label="归还人"/>
                            <el-table-column prop="revertLife" sortable label="使用次数"/>
                            <el-table-column prop="residualLife" sortable label="剩余次数"/>
                            <el-table-column prop="createTime" sortable label="归还时间" width="160"/>
                            <el-table-column prop="revertFile" sortable label="归还照片">
                                <template slot-scope="scope">
                                    <el-popover placement="left" trigger="click" width="500">
                                        <img :src="scope.row.revertFile" width="100%"/>
                                        <img slot="reference" :src="scope.row.revertFile" :alt="scope.row.revertFile"
                                             style="max-height: 80px; max-width: 80px; padding: 5px"/>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" sortable label="备注"/>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <el-dialog title="工装导入" :visible.sync="toolingImportShow">
            <el-upload
                class="upload-demo"
                drag
                :headers="{'X-Auth-Token':token}"
                :action="deviceURL"
                :on-success="itemSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
        </el-dialog>
    </div>
</template>

<script>
    import { findUserByAccount, getRevertRecordToolingCode, getUseRecordToolingCode } from '../../../libs/api'
    import moment from 'moment'
    import jQuery from 'jquery'

    export default {
        name: 'toolingInfo',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                classifyList: [],
                unitList: [],
                toolingInfoList: [],
                ifAddText: '',
                factoryTree: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                unit: '',
                classifyId: '',
                toolingStatus: '',
                toolingName: '',
                toolingCode: '',
                record: false,
                recordShow: false,
                tooLingShow: false,
                updateRecordTitle: '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7
                    }
                },
                URL: '',
                token: '',
                deviceURL: '',
                clearFiles: '',
                fileList: [],
                fileUrlShow: false,
                fileUpload: false,
                refObj: '',
                useRecordInfo: {
                    tiId: '',
                    remark: '',
                    useTimeEnd: '',
                    useUser: '',
                    useFile: '',
                    useUserName: ''
                },
                useRecord: {
                    tiId: [
                        {
                            required: true,
                            message: '请选择工装编码',
                            trigger: 'blur'
                        }
                    ],
                    remark: [
                        {
                            type: 'string',
                            required: true,
                            message: '请输入备注',
                            trigger: 'blur'
                        }
                    ],
                    useTimeEnd: [
                        {
                            required: true,
                            message: '请选择归还时间',
                            trigger: 'blur'
                        }
                    ],
                    useUser: [
                        {
                            required: true,
                            message: '请输入员工工号',
                            trigger: 'blur'
                        }
                    ]
                },
                revertRecordInfo: {
                    tiId: '',
                    remark: '',
                    revertFile: '',
                    revertUser: '',
                    revertLife: '',
                    revertUserName: ''
                },
                revertRecord: {
                    tiId: [
                        {
                            required: true,
                            message: '请选择工装编码',
                            trigger: 'blur'
                        }
                    ],
                    remark: [
                        {
                            type: 'string',
                            required: true,
                            message: '请输入备注',
                            trigger: 'blur'
                        }
                    ],
                    revertUser: [
                        {
                            required: true,
                            message: '请输入员工工号',
                            trigger: 'blur'
                        }
                    ],
                    revertLife: [
                        {
                            required: true,
                            message: '请输入使用次数',
                            trigger: 'blur'
                        }
                    ]
                },
                userOrg: false,
                userName: '',
                useList: [],
                revertList: [],
                activeName: 'first',
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                userList: [],
                loading: false,
                options: [],
                value: [],
                list: [],
                enumTypeList: [],
                toolingImportShow: false,
                sortField: 'tooling_code',
                sortOrder: 'ASC'
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.URL = 'https://tpm.joysonsafety.com.cn/api/upload/files'
            this.token = sessionStorage.getItem('authToken')
            this.init()
        },
        activated() {
            this.init()
        },
        methods: {
            init() {
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.isclear = true
                        this.role = role[i]
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getData()
                this.getUnitList()
                this.getEunmTypeList()
            },
            updateToolingRecord() {
                if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
                    this.$message.error('请选择工厂！')
                    return
                }
                this.fileList = []
                if (this.refObj != null && this.refObj != '') {
                    this.$refs[this.refObj].resetFields()
                }
                if (this.record) {
                    this.updateRecordTitle = '工装领用'
                    this.refObj = 'useRecord'
                    this.useRecordInfo = {}
                } else {
                    this.updateRecordTitle = '工装归还'
                    this.refObj = 'revertRecord'
                    this.revertRecordInfo = {}
                }
                this.recordShow = true
                this.fileUrlShow = true
                this.fileUpload = true
                this.getToolingInfoList()
            },
            handleSuccess(res, file) {
                this.fileList = []
                if (this.record) {
                    this.fileUrlShow = true
                    this.fileUpload = true
                    this.useRecordInfo.useFile = file.response.data
                } else {
                    this.fileUrlShow = true
                    this.fileUpload = true
                    this.revertRecordInfo.revertFile = file.response.data
                }
            },
            fcChange: function() {
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                this.classifyId = ''
                // this.getData();
                this.searchTable()
                this.getUserList()
                this.getToolingClassifyList()
            },
            shopChange: function() {
                this.sectionSelected = ''
                this.lineSelected = ''
                // this.getData();
                this.searchTable()
            },
            sectionChange: function() {
                this.lineSelected = ''
                // this.getData();
                this.searchTable()
            },
            lineChange: function() {
                // this.getData();
                this.searchTable()
            },
            toolingTemplate() {
                if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
                    this.$message.error('请选择工厂！')
                    return
                }
                var inputs = ''
                inputs += '<input type="hidden" name="token" value="' + this.token + '" />'
                if (this.fcIdSelected != '' && this.fcIdSelected != undefined) {
                    inputs += '<input type="hidden" name="fcCode" value="' + JSON.parse(this.fcIdSelected).deptCode + '" />'
                }
                var url = this.$api.toolingTemplate

                jQuery('<form action="' + url + '" method=POST>' + inputs + '</form>')
                    .appendTo('body').submit().remove()
            },
            // 排序方式、字段点击事件
            sortFOChange() {
                this.sortOrder = ''
                this.searchTable()
            },
            toolingImport() {
                if (this.fcIdSelected == undefined || this.fcIdSelected == '') {
                    this.$message.error('请选择工厂！')
                    return
                }
                if (this.fcIdSelected != '' && this.fcIdSelected != undefined) {
                    this.toolingImportShow = true
                    this.deviceURL = this.$api.toolingImport + '?fcCode=' + JSON.parse(this.fcIdSelected).deptCode
                }
            },
            itemSuccess(resp) {
                if (resp.status == 101) {
                    alert(resp.message)
                } else if (resp.status == 100) {
                    this.$message.success('导入成功')
                    this.toolingImportShow = false
                    this.searchTable()
                }
            },
            async exportToolingInfo() {
                let queryParams = {}
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(this.lineSelected).deptCode
                }
                if (this.unit != undefined && this.unit != '') {
                    queryParams['unitCode'] = this.unit
                }
                if (this.classifyId != undefined && this.classifyId != '') {
                    queryParams['classifyId'] = this.classifyId
                }
                if (this.toolingStatus != undefined && this.toolingStatus != '') {
                    queryParams['toolingStatus'] = this.toolingStatus
                }
                if (this.toolingName != undefined && this.toolingName != '') {
                    queryParams['toolingName'] = this.toolingName
                }
                if (this.toolingCode != undefined && this.toolingCode != '') {
                    queryParams['toolingCode'] = this.toolingCode
                }

                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportToolingInfo,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '工装台账信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            exportToolingInfoRecord() {
                this.exportRevertRecordTooling()
                this.exportToolingUseRecord()
            },
            /*归还导出*/
            async exportRevertRecordTooling() {
                let queryParams = {}
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(this.lineSelected).deptCode
                }
                if (this.unit != undefined && this.unit != '') {
                    queryParams['unitCode'] = this.unit
                }
                if (this.classifyId != undefined && this.classifyId != '') {
                    queryParams['classifyId'] = this.classifyId
                }
                if (this.toolingStatus != undefined && this.toolingStatus != '') {
                    queryParams['toolingStatus'] = this.toolingStatus
                }
                if (this.toolingName != undefined && this.toolingName != '') {
                    queryParams['toolingName'] = this.toolingName
                }
                if (this.toolingCode != undefined && this.toolingCode != '') {
                    queryParams['toolingCode'] = this.toolingCode
                }

                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportRevertRecordTooling,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '工装归还信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            /*工装领用导出*/
            async exportToolingUseRecord() {
                let queryParams = {}
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(this.lineSelected).deptCode
                }
                if (this.unit != undefined && this.unit != '') {
                    queryParams['unitCode'] = this.unit
                }
                if (this.classifyId != undefined && this.classifyId != '') {
                    queryParams['classifyId'] = this.classifyId
                }
                if (this.toolingStatus != undefined && this.toolingStatus != '') {
                    queryParams['toolingStatus'] = this.toolingStatus
                }
                if (this.toolingName != undefined && this.toolingName != '') {
                    queryParams['toolingName'] = this.toolingName
                }
                if (this.toolingCode != undefined && this.toolingCode != '') {
                    queryParams['toolingCode'] = this.toolingCode
                }

                let options = {
                    method: 'POST',
                    params: queryParams,
                    url: this.$api.exportToolingUseRecord,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '工装领用信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            updateRecord(rules) {
                /*if (this.record) {
                    if (this.useRecordInfo.useFile == undefined || this.useRecordInfo.useFile == '') {
                        this.$message.error('请选择领用照片！')
                        return
                    }
                } else {
                    if (this.revertRecordInfo.revertFile == undefined || this.revertRecordInfo.revertFile == '') {
                        this.$message.error('请选择归还照片！')
                        return
                    }
                }*/
                this.$refs[rules].validate((valid) => {
                    if (valid) {
                        if (!this.userOrg) {
                            this.$message.error('请输入正确的工号！')
                            return
                        }
                        this.formSubmit()
                    } else {
                        return false
                    }
                })
            },
            formSubmit() {
                this.record == true ? this.useRecordInfo.useUserName = this.userName : this.revertRecordInfo.revertUserName = this.userName
                // this.record == true ? this.useRecordInfo.useTimeEnd = moment(this.useRecordInfo.useTimeEnd).format('YYYY-MM-DD') : ''
                if (this.record) {
                    if (this.useRecordInfo.useTimeEnd != undefined && this.useRecordInfo.useTimeEnd != '') {
                        this.useRecordInfo.useTimeEnd = moment(this.useRecordInfo.useTimeEnd).format('YYYY-MM-DD')
                    }
                }
                let options = {
                    method: 'POST',
                    url: this.record == true ? this.$api.addToolingUse : this.$api.addToolingRevert,
                    data: this.record == true ? this.useRecordInfo : this.revertRecordInfo
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.$message.success(this.record == true ? '领用成功！' : '归还成功！')
                        this.recordShow = false
                        this.searchTable()
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            queryUserByAccount() {
                let params = {
                    userAccount: this.record == true ? this.useRecordInfo.useUser : this.revertRecordInfo.revertUser
                }
                let options = {
                    method: 'get',
                    url: this.$api.findUserByAccount,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.userOrg = true
                            for (let i = 0; i < response.data.length; i++) {
                                this.userName = response.data[i].userName
                            }
                        } else {
                            this.$message.error('此工号不存在系统！')
                            this.userOrg = false
                        }
                    }
                })
            },
            toolingReCord(row) {
                this.tooLingShow = true
                this.getUseRecordTiId(row.tiId)
                this.getRevertRecordTiId(row.tiId)
            },
            getUseRecordTiId(tiId) {
                let params = {
                    tiId: tiId
                }
                let options = {
                    method: 'get',
                    url: this.$api.getUseRecordToolingTiId,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.useList = response.data
                    }
                })
            },
            getRevertRecordTiId(tiId) {
                let params = {
                    tiId: tiId
                }
                let options = {
                    method: 'get',
                    url: this.$api.getRevertRecordToolingTiId,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.revertList = response.data
                    }
                })
            },
            updateLingInfo(row) {
                this.$router.push({
                    name: 'addlingInfo',
                    params: {
                        lingInfo: row,
                        ifAddText: this.ifAddText
                    }
                })
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            deleteRow(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                headers: { 'content-type': 'application/json' },
                                params: { tiId: row.tiId },
                                url: this.$api.deleteToolingInfo
                            })
                            .then(response => {
                                this.searchTable()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.searchTable()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            getUnitList() {
                let options = {
                    method: 'get',
                    url: this.$api.unitList
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.unitList = response.data
                    }
                })
            },
            getUserList() {
                var params = {}
                if (this.ischeck) {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.userList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.userList = response.data
                        this.remoteList()
                    }
                })
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true
                    setTimeout(() => {
                        this.loading = false
                        this.options = this.list.filter(item => {
                            return item.label.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1
                        })
                    }, 200)
                } else {
                    this.options = []
                }
            },
            remoteList() {
                if (this.userList != undefined && this.userList != '') {
                    this.list = this.userList.map(item => {
                        return { value: item.userAccount, label: item.userAccount + '(' + item.userName + ')' }
                    })
                } else {
                    this.list = []
                }
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    this.searchTable()
                    this.getUserList()
                    this.getToolingClassifyList()
                })
            },
            getToolingClassifyList() {
                let params = {}
                this.classifyList = []
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                } else {
                    return
                }
                let options = {
                    method: 'get',
                    url: this.$api.toolingClassifyList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.classifyList = response.data
                    }
                })
            },
            getToolingInfoList() {
                let params = {
                    toolingStatus: this.record ? 'id_le' : 'in_use'
                }
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    params['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.toolingInfoList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.toolingInfoList = response.data
                    }
                })
            },
            getEunmTypeList() {
                this.enumTypeList = []
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.enumTypelist,
                    params: {
                        enumType: 'tool_status'
                    }
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.enumTypeList = [
                            {
                                etName: '闲置中',
                                etCode: 'id_le'
                            },
                            {
                                etName: '领用中',
                                etCode: 'in_use'
                            },
                            {
                                etName: '报废中',
                                etCode: 'scrap'
                            },
                            {
                                etName: '调试中',
                                etCode: 'debugging'
                            },
                            {
                                etName: '使用中',
                                etCode: 'make_use'
                            },
                            {
                                etName: '已移管',
                                etCode: 'moved_tube'
                            }
                        ]
                        if (response.data != undefined && response.data != '') {
                            self.enumTypeList = []
                            var aa = response.data
                            for (let i = 0; i < aa.length; i++) {
                                var array = {
                                    etName: '',
                                    etCode: ''
                                }
                                array.etName = aa[i].etName
                                array.etCode = aa[i].etCode
                                self.enumTypeList.push(array)
                            }
                        }
                    }
                })
            },
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
                }
                if (this.shopSelected != undefined && this.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(this.shopSelected).deptCode
                }
                if (this.sectionSelected != undefined && this.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
                }
                if (this.lineSelected != undefined && this.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(this.lineSelected).deptCode
                }
                if (this.unit != undefined && this.unit != '') {
                    queryParams['unitCode'] = this.unit
                }
                if (this.classifyId != undefined && this.classifyId != '') {
                    queryParams['classifyId'] = this.classifyId
                }
                if (this.toolingStatus != undefined && this.toolingStatus != '') {
                    queryParams['toolingStatus'] = this.toolingStatus
                }
                if (this.toolingName != undefined && this.toolingName != '') {
                    queryParams['toolingName'] = this.toolingName
                }
                if (this.toolingCode != undefined && this.toolingCode != '') {
                    queryParams['toolingCode'] = this.toolingCode
                }
                if (this.sortField != undefined && this.sortField != '') {
                    queryParams['sortField'] = this.sortField
                }
                if (this.sortOrder != undefined && this.sortOrder != '') {
                    queryParams['sortOrder'] = this.sortOrder
                }
                let options = {
                    method: 'get',
                    url: this.$api.getAllToolingInfo,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
